import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import VueJwtDecode from 'vue-jwt-decode'

import datatable from './modules/datatable.store'
import filter from './modules/filter.store'
import modalStore from './modules/modal'
import addEdit from './modules/addEdit'
import searchStore from './modules/search'
import editStore from './modules/edit'
import level1 from './modules/level1'
import landingpage from './modules/landingpage'
import modalReqApp from './modules/modalRequestApproval'
import myRequest from './modules/myrequest.store'
import approvalSheet from './modules/approval.store'
import k3lStore from './modules/k3lStore'
import kplhStore from './modules/kplhStore'

import { api } from '../services/config'
import { mixin } from '@/mixins/helper'
import { permissionData } from './general_permission'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    globalLoading: false,
    showModalLogin: false,
    showModalReset: false,
    showModalForgot: false,
    showModalNotif: false,
    notifText: '',
    csv_data: null,
    currentUser: null,
    currentEmail: null,
    userid: null,
    permissions: null,
    token: null,
    role_id: null,
    spmDashboardDetail: null,
    spmDashboardSummary: null,
    spmDashboardCompany: null,
    spmDashboardFrom: null,
    spmDashboardTo: null,
    csiDashboardDetail: null,
    csiDashboardSummary: null,
    csiDashboardCompany: null,
    csiDashboardYearFrom: null,
    csiDashboardMonthFrom: null,
    csiDashboardYearTo: null,
    csiDashboardMonthTo: null,
  },

  mutations: {
    SET_CSV_DATA(state, data) {
      state.csv_data = data
    },
    AUTO_LOGIN(state) {
      const isToken = localStorage.getItem('token')
      const isPermissions = JSON.parse(localStorage.getItem('permissions'))
      if (isToken && isPermissions) {
        const dec = VueJwtDecode.decode(isToken)
        state.currentUser = dec.name
        state.currentEmail = dec.email
        state.userid = dec.id
        state.role_id = isPermissions[0].role_id
        state.permissions = isPermissions.reduce(
          (obj, item) => (
            (obj[item.permission_id] = {
              allow: item.allow == 1 ? true : false,
              modul: mixin.methods.$get(item, 'permission.modul'),
              function: mixin.methods.$get(item, 'permission.function'),
            }),
            obj
          ),
          {}
        )
        state.token = isToken
      } else {
        state.permissions = permissionData.reduce(
          (obj, item) => (
            (obj[item.permission_id] = {
              allow: item.allow == 1 ? true : false,
              modul: mixin.methods.$get(item, 'permission.modul'),
              function: mixin.methods.$get(item, 'permission.function'),
            }),
            obj
          ),
          {}
        )
      }
    },
    // Currently only available for SIPM
    UNSET_CURRENT_USER(state) {
      state.currentUser = null
      state.currentEmail = null
      state.userid = null
      state.role_id = null
      localStorage.removeItem('token')
      localStorage.removeItem('permissions')
      state.permissions = permissionData.reduce(
        (obj, item) => (
          (obj[item.permission_id] = {
            allow: item.allow == 1 ? true : false,
            modul: mixin.methods.$get(item, 'permission.modul'),
            function: mixin.methods.$get(item, 'permission.function'),
          }),
          obj
        ),
        {}
      )
      state.token = null
    },
    SET_PERMISSIONS(state, permissions) {
      localStorage.setItem('permissions', JSON.stringify(permissions))
      state.permissions = permissions.reduce(
        (obj, item) => (
          (obj[item.permission_id] = {
            allow: item.allow == 1 ? true : false,
            modul: mixin.methods.$get(item, 'permission.modul'),
            function: mixin.methods.$get(item, 'permission.function'),
          }),
          obj
        ),
        {}
      )
    },
    SET_TOKEN(state, token) {
      state.token = token
      localStorage.setItem('token', token)
      const dec = VueJwtDecode.decode(token)
      state.currentEmail = dec.email
      state.currentUser = dec.name
      state.userid = dec.id
    },
    SET_LEGALDOC_EDIT(state, value) {
      state.isLegaldocEdit = value
    },
    async GET_PERMISSIONS(state) {
      const { data } = await axios({
        url: `${api}/api/v1/auth/permissions`,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
      })

      state.permissions = {
        access: data.data.access,
        filter: data.data.filter,
      }
    },
    SET_SPM_DASHBOARD(state, data) {
      state.spmDashboardDetail = data.spmDetail
      state.spmDashboardSummary = data.spmSummary
      state.spmDashboardCompany = data.spmCompany
      state.spmDashboardFrom = data.spmFrom
      state.spmDashboardTo = data.spmTo
    },
    SET_CSI_DASHBOARD(state, data) {
      state.csiDashboardDetail = data.csiDetail
      state.csiDashboardSummary = data.csiSummary
      state.csiDashboardCompany = data.csiCompany
      state.csiDashboardYearFrom = data.csiYearFrom
      state.csiDashboardMonthFrom = data.csiMonthFrom
      state.csiDashboardYearTo = data.csiYearTo
      state.csiDashboardMonthTo = data.csiMonthTo
    },
    SET_MODAL_LOGIN(state, status) {
      state.showModalLogin = status
    },
    SET_MODAL_RESET(state, status) {
      state.showModalReset = status
    },
    SET_MODAL_FORGOT(state, status) {
      state.showModalForgot = status
    },
    SET_NOTIF(state, msg) {
      state.showModalNotif = true
      state.notifText = msg

      setTimeout(() => {
        state.showModalNotif = false
        state.notifText = ''
      }, 2000)
    },
    DONT_HAVE_PERMISSIONS(state, msg) {
      state.showModalNotif = true
      state.notifText = `Maaf, anda tidak memiliki akses`

      setTimeout(() => {
        state.showModalNotif = false
        state.notifText = ''
      }, 2000)
    },
    SET_GLOBAL_LOADING(state, payload) {
      state.globalLoading = payload
    },
  },
  actions: {
    async login({ dispatch, commit }, params) {
      await commit('SET_CURRENT_USER', params)
      await dispatch('checkLogin')
    },
    logout({ commit }) {
      commit('UNSET_CURRENT_USER')
    },
  },
  modules: {
    datatable,
    filter,
    modalStore,
    addEdit,
    editStore,
    searchStore,
    level1,
    landingpage,
    modalReqApp,
    myRequest,
    approvalSheet,
    k3lStore,
    kplhStore,
  },
})
